export default __webpack_public_path__ + "static/media/trans-custom.44daadc5.png";